@use "@fukuri-admins/ui/layout" as *;

.tableRow {
  transition: background-color 0.2s ease-out;
  cursor: pointer;
  &:hover {
    background-color: $WhiteHover;
  }
}

.tableCell {
  font-size: 16px !important;
  line-height: 54px;
  font-weight: normal;
  border-bottom: 1px solid $Border;
  &.MuiTableCell-root {
    padding: 0;
  }
}

.emptyTable {
  font-size: 40px;
  color: $NATURAL_400;
  text-align: center;
  margin: 100px auto;
  height: 326px;
}

.action {
  display: flex;
  align-items: center;
  justify-content: center;
}

.actionIcon {
  & i {
    cursor: pointer;
  }
  &:hover {
    opacity: 0.5;
  }
}

.marginRight10 {
  margin-right: 5px;
}

.cellA {
  padding: 8px 16px;
  color: inherit;
  text-decoration: none;
}

// .tableCellPadding {
//   padding: 10px 10px 10px 20px !important;
// }
